import { useEffect, useState } from "react";
import { connect, useDispatch } from 'react-redux';
import { requestClientes, requestClientesSearch } from '../../actions/cliente';
import { Grid, TextField, Container } from "@mui/material";
import Dolar from "../../common/dolar";
import colores from "../../shared/constants/styles";
import Cliente from './cliente';

const Clientes = (props) => {

  const dispatch = useDispatch();
  const [nombre, setNombre] = useState(null);
  useEffect(() => {
    dispatch(requestClientes());
  }, []);
  const { clientes } = props;

  const handleSearch = () => {
    nombre ? dispatch(requestClientesSearch(nombre)) : dispatch(requestClientes())
  }

  const handleClean = (event) => {
    event.preventDefault();
    setNombre("");
    dispatch(requestClientes());
  };

  const handleNombreToChange = (event) => {
    setNombre(event.target.value);
  };

  return (
    <div
      style={{
        backgroundColor: colores.grisClaro,
        overflow: "hidden",
        clear: "both",
      }}
    >
      <div>
        <Dolar></Dolar>
        <div
          className="container-fluid"
          style={{
            width: "100%",
            overflow: "hidden",
            clear: "both",
            margin: "1.85rem",
          }}
        >  
          <div className="d-flex justify-content-center">
            <hr style={{ width: "90%", color: "black", marginTop: "0" }}></hr>
          </div>
          <Container
            maxWidth="w-100"
            style={{ paddingRight: "60px", paddingLeft: "60px" }}
          >
            <div
              className="d-flex justify-content-between flex-wrap align-items-center "
              style={{ marginBottom: "0.600rem", paddingRight: "3.5rem" }}
            >
              <h1 className="fw-bolder" style={{ fontSize: "bolder" }}>
                CLIENTES
              </h1>
            </div>
          </Container> 
        </div>     
        <div
          className="container-fluid mx-0 px-0 w-100"
          style={{ margin: "2rem" }}
        >
          <div
            className="container-fluid"
            style={{
              backgroundColor: "white",
              width: "100%",
              overflow: "hidden",
              clear: "both",
              marginBottom: "1.85rem",
              paddingLeft: "76px",
              paddingRight: "76px",
            }}
          >
          <div
              className="d-flex justify-content-between"
              style={{ margin: "2rem 0" }}
            >
            <TextField
                id="nombre"
                value={nombre}
                name="nombre"
                onChange={handleNombreToChange}
                label="Nombre de cliente"
                variant="outlined"
              />
            <div className="d-flex align-items-end">
              <button
                type="submit"
                style={{ background: colores.rojo, color: "white" }}
                class="btn"
                onClick={handleSearch}
              >
                Buscar
              </button>
              <button
                style={{
                background: colores.white,
                color: "red",
                borderColor: "red",
                marginLeft: "2vh",
                }}
                class="btn"
                onClick={handleClean}
              >
                Limpiar
              </button>
            </div>
          </div>
          <Grid>
            {!props.loading ? (
              <Grid container spacing={3}>
                {clientes?.map(cliente => (<Cliente key={cliente.id} data={cliente}/>))}
              </Grid>
            ) : (
              <h1>Cargando clientes...</h1>
            )}
          </Grid> 
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect
(
  state => ({
    clientes: state.clientes.clientes,
    loading: state.clientes.loading
  }),
  dispatch => ({    
    requestClientesSearch: (search) => dispatch(requestClientesSearch(search)),
    requestClientes: () => dispatch(requestClientes())
  })
)(Clientes);